import React, { Component, Fragment, useState } from "react";



import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



import { useCustomizeContext } from "../../context";

import { useEffect } from "react";

import { useParams } from "react-router";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Radio } from "react-loader-spinner";

import LoadingOverlay from 'react-loading-overlay';

import { useTranslation, I18nextProvider } from "react-i18next";

import { verifyMail } from "../../Features/Password/passwordSlice";

const VerificationForget = (props) => {
    const { t, i18n } = useTranslation();

    const {
        loader: {
            loading, setLoading
        },
        modelStatus: {
            modal, setModal,
            modal1, setModal1,
            modal2, setModal2, modal3, setModal3,
        },
        forget: {
            forgetCode, setForgetCode
        }
    } = useCustomizeContext();


    var settings = {
        dots: false,
        infinite: true,
        arrows: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
        ]
    };

    let { id } = useParams();
    let dispatch = useDispatch();
    let navigate = useNavigate();

    useEffect(() => {
        verifyUser();
    }, []);


    const verifyUser = async () => {
        setLoading(true);
        let res = await dispatch(verifyMail(id));
        if (res?.status) {
            setForgetCode(id);
            setLoading(false);
            navigate("/");
            setModal3(!modal3);
        }
        else {
            setLoading(false);
            navigate("/");
        }
    }



    return (
        <Fragment>
            <LoadingOverlay
                active={loading}
                spinner={
                    <Radio
                        visible={true}
                        height="600"
                        width="600"
                        // colors={['#fff', '#fff', '#fff']}
                        ariaLabel="radio-loading"
                        wrapperStyle={{}}
                        wrapperClass="radio-wrapper"
                    />


                }
                styles={{ color: "#faa625", zIndex: "9999" }}
            >
                {t("loading")}
            </LoadingOverlay>
        </Fragment>
    );

}

export default VerificationForget;